
import React from 'react';
import PropTypes from 'prop-types';

const TextArea = ({
    label,
    name,
    value,
    onChange,
    rows = 4,
    placeholder,
    className = '',
    style = {},
    ...props
}) => {


    const inputStyles = {
        background: 'rgba(255, 255, 255, 0.1)',
        border: '1px solid rgba(255, 255, 255, 0.2)',
        color: '#fff',
        padding: '12px',
        borderRadius: '8px',
        width: '100%',
        boxSizing: 'border-box',
        fontSize: '1rem',
        fontFamily: 'inherit',
        resize: 'vertical',
        transition: 'border-color 0.2s',
        ...style
    };

    return (
        <div className={`form-group ${className}`} style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            {label && <label style={{ color: '#fff', fontSize: '0.9rem' }}>{label}</label>}
            <textarea
                name={name}
                value={value}
                onChange={onChange}
                rows={rows}
                placeholder={placeholder}
                style={inputStyles}
                onFocus={(e) => {
                    e.target.style.borderColor = '#d90429';
                    e.target.style.outline = 'none';
                }}
                onBlur={(e) => {
                    e.target.style.borderColor = 'rgba(255, 255, 255, 0.2)';
                }}
                {...props}
            />
        </div>
    );
};

TextArea.propTypes = {
    label: PropTypes.string,
    name: PropTypes.string.isRequired,
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    rows: PropTypes.number,
    placeholder: PropTypes.string,
    className: PropTypes.string,
    style: PropTypes.object
};

export default TextArea;
